<div class="name">
  <h3>{{ platformName }}</h3>
  <span *ngIf="lastSync">Last Sync: {{ lastSync | date:'short' }}</span>
</div>
<div class="sync-progress-wrap">
  <div class="sync-progress" [ngStyle]="{'width': percentText}" [ngClass]="{'in-progress': inProgress}"></div>
</div>